var map = {
	"./checkbox-false.svg": "5Ivo",
	"./radio-false.svg": "z0Pm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AJyC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\-false\.svg$
// module id = AJyC
// module chunks = 26